import React from "react";

const CppPocketGuidePrivacy = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>C++ Pocket Guide</h1>
        <p style={styles.subtitle}>Privacy Policy</p>
        <p style={styles.date}>Last updated: April 2026</p>

        <Section title="1. Information Collection">
          C++ Pocket Guide does not collect, store, or share any personal data.
          This is a completely offline application.
        </Section>

        <Section title="2. Usage Data">
          The app does not track user activity, analytics, or usage data of any kind.
        </Section>

        <Section title="3. Internet Usage">
          This app does not require an internet connection and does not transmit
          any data to external servers.
        </Section>

        <Section title="4. Third-Party Services">
          This app does not use any third-party services, analytics tools, or ads.
        </Section>

        <Section title="5. Data Security">
          Since no data is collected or stored, there is no risk of data misuse.
        </Section>

        <Section title="6. Changes to This Policy">
          Any future updates to the app that affect privacy will be reflected in this policy.
        </Section>

        <Section title="7. Contact">
          If you have any questions, you can contact us at:
          <br />
          <strong style={styles.email}>adidada023@gmail.com</strong>
        </Section>
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div style={styles.section}>
    <h2 style={styles.sectionTitle}>{title}</h2>
    <p style={styles.text}>{children}</p>
  </div>
);

const styles = {
  page: {
    backgroundColor: "#f5f7fa",
    minHeight: "100vh",
    padding: "20px",
  },
  container: {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "30px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.7",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    marginBottom: "5px",
  },
  subtitle: {
    fontSize: "18px",
    color: "#555",
    marginBottom: "10px",
  },
  date: {
    fontSize: "14px",
    color: "#888",
    marginBottom: "25px",
  },
  section: {
    marginBottom: "20px",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "8px",
  },
  text: {
    fontSize: "15px",
    color: "#444",
  },
  email: {
    color: "#007bff",
  },
};

export default CppPocketGuidePrivacy;